import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import AuctionBase from "../AuctionBase";
import React from "react";

import { getProto } from "../../../utils/proto/index";

export const SealedAuction = ({
  auction,
  shopId,
  productId,
  now,
  endEpoch,
  onPlaceBid,
  customerId,
  shopLoginUrl,
  statefulPurchaseQuantity,
  setStatefulPurchaseQuantity,
  setVariant,
  activeBid,
}) => {
  const placementNote =
    "you will be able to buy the item if your bid is in the top 1000 winners.";

  return (
    <AuctionBase
      auction={auction}
      targetDate={endEpoch}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      onBidClick={onPlaceBid}
      setVariant={setVariant}
      placementNote={placementNote}
      activeBid={activeBid}
    />
  );
};
